/**
 * The rail's collapse, remembered per person on this computer (app-shell.md C, TC-UI-008):
 * `localStorage vintner.rail.<tenant>.<user>` = "collapsed"; expanded stores nothing. Blocked storage
 * (private mode) reads as expanded and the choice lasts for the page's life. Switch user and the idle
 * sign-out (ALN-128) call `forgetRail` so the next person on a shared computer starts expanded.
 */
export const railKey = (tenant: string, user: string) => `vintner.rail.${tenant}.${user}`;

function local(): Storage | null {
  try { return typeof window === "undefined" ? null : window.localStorage; } catch { return null; }
}

export function readRail(tenant: string | null | undefined, user: string | null | undefined, store: Storage | null = local()): boolean {
  if (!tenant || !user || !store) return false;
  try { return store.getItem(railKey(tenant, user)) === "collapsed"; } catch { return false; }
}

export function writeRail(tenant: string | null | undefined, user: string | null | undefined, collapsed: boolean, store: Storage | null = local()): void {
  if (!tenant || !user || !store) return;
  try {
    if (collapsed) store.setItem(railKey(tenant, user), "collapsed");
    else store.removeItem(railKey(tenant, user));
  } catch { /* private mode: the choice lasts for the page's life */ }
}

export function forgetRail(tenant: string | null | undefined, user: string | null | undefined, store: Storage | null = local()): void {
  writeRail(tenant, user, false, store);
}
